export const SIGNAL_CODE_KEY = 'signal-code'
export const MY_PHONE_NUMBER = 'my-phone-number'
export const LOCATION_RADIUS_SETUP = 'location-setup-radius'
export const BLINKING_TYPE = 'blinking-type'
export const BLINKING_TYPE_SETUP = 'setup-type-blink'
export const LIGHT_POWER = 'light-power'
export const CURRENT_LOCATION = 'my-location'
export const LOCATION_SETUP = 'location-setup'
export const RIVER_BRANCH = 'river-branch'
export const SIGNAL_TYPE = 'signal-type'
export const SIGNAL_COLOR = 'signal-color'
export const SIGNAL_LIGHT_COLOR = 'signal-light-color'
export const VOLTAGE = 'voltage'
export const CURRENT = 'current'
export const SIGNAL_STATUS = 'status'
export const SETUP_TYPE_CHECK_GPS = 'setup-type-check-gps'
export const SETUP_TIME = 'setup-time'
export const LOCATION = 'location'
export const PARENT_ID = 'parentId'
export const DESCRIPTION = 'description'
export const PRODUCTION_NUMBER = 'production-number'

export const PROPERTY_DISPLAY_NAME = {
  [SIGNAL_CODE_KEY]: 'Mã báo hiệu',
  [MY_PHONE_NUMBER]: 'Số điện thoại',
  [LOCATION_RADIUS_SETUP]: 'Bán kính vị trí cài đặt',
  [BLINKING_TYPE]: 'Kiểu chớp',
  [LIGHT_POWER]: 'Công suất chiếu sáng',
  [CURRENT_LOCATION]: 'Toạ độ hiện tại',
  [LOCATION_SETUP]: 'Toạ độ cài đặt',
  [RIVER_BRANCH]: 'Tuyến sông',
  [SIGNAL_COLOR]: 'Màu báo hiệu',
  [SIGNAL_LIGHT_COLOR]: 'Màu đèn báo hiệu',
  [VOLTAGE]: 'Điện áp',
  [CURRENT]: 'Dòng điện',
  [SIGNAL_STATUS]: 'Trạng thái báo hiệu',
  [LOCATION]: 'Toạ độ',
  [DESCRIPTION]: 'Mô tả thêm',
  [PRODUCTION_NUMBER]: 'Mã sản xuất',
}

export const DEVICE_PROPERTY_CODES = {
  VIJ_SIGNAL_TYPE: 'VIJ_SIGNAL_TYPE',
  RIVER_BRANCH: 'RIVER_BRANCH',
  VIJ_BLINKING_TYPE: 'VIJ_BLINKING_TYPE',
  VIJ_SIGNAL_LIGHT_STATUS: 'VIJ_SIGNAL_LIGHT_STATUS',
  VIJ_SIGNAL_COLOR: 'VIJ_SIGNAL_COLOR',
  VIJ_LIGHT_POWER: 'VIJ_LIGHT_POWER',
  VIJ_SIGNAL_LIGHT_COLOR: 'VIJ_SIGNAL_LIGHT_COLOR',
  DESCRIPTION: 'DESCRIPTION',
  PRODUCTION_NUMBER: 'PRODUCTION_NUMBER',
}
